<template>
  <text
    ref="svg_text"
    :x="x"
    :y="y"
    :fill="getColorWarningHipScore(actualScore)"
    >{{ value }}</text>
</template>
<script>
import {
  getColorWarningHipScore,
  getLabelHorizontalPosition,
  getLabelVerticalPosition,
} from "./constant";
export default {
  name: "PointLabel",
  props: {
    actualSize: Number,
    value: String,
    actualScore: String,
    point: Object,
  },
  data() {
    return {
      getColorWarningHipScore,
      x: 0,
      y: 0,
    };
  },
  mounted() {
    this.handleResponsive();
  },

  watch: {
    actualSize: {
        handler() {
            this.handleResponsive()
        }
    },
  },

  methods: {
    handleResponsive(){
      this.x =
      -this.$refs.svg_text.getBBox().width / 2 +
      this.point.x +
      getLabelHorizontalPosition({
        point: this.point,
        actualSize: this.actualSize,
      });
    this.y =
      this.$refs.svg_text.getBBox().height / 2 +
      this.point.y +
      getLabelVerticalPosition({
        point: this.point,
        actualSize: this.actualSize,
      });
    }
  }
};
</script>